// extracted by mini-css-extract-plugin
export var column = "_tp-0";
export var divider = "_tp-2";
export var timePicker = "_tp-1";